module.exports = __webpack_public_path__ + "static/media/quantware.c0efc86c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/quantware.webp
// module id = 878
// module chunks = 0